import { styled } from 'styled-components';

import { useEffect, useRef, useState } from 'react';
import { Box, Divider, Heading, Stack, Text } from '@chakra-ui/react';
import { ReactComponent as iconLeft } from "../assets/icons/icon-arrow-left.svg";
import { ReactComponent as iconRight } from "../assets/icons/icon-arrow-right.svg";

const Container = styled.div`
  // height: calc(100vh - 90px);
  // overflow-y: hidden;
`;

const NavSection = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  border-top: 1px solid #969696;
  border-bottom: 1px solid #969696;
  z-index: 10;
`;

const RowBox = styled.div`
  display: flex;
  width: 80%;
  height: 40px;
  overflow: hidden;
`;

const NavBox = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
`;

const ScrollSection = styled.div`
&::-webkit-scrollbar {
  display: none;
}
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  width: 100%;
  height: calc(100vh - 40px);
  overflow-y: scroll;
`;

const StyledButton = styled.button<{ $isselect: string }>`
  background: none;  
  width: 20%;
  min-width: 20%;
  color: ${(props) => props.$isselect === "true" ? "#333333" : "#979797"};
  font-weight: ${(props) => props.$isselect === "true" ? "600" : "400"};
  border-bottom: ${(props) => props.$isselect === "true" ? "2px solid #27C4D5" : "none"};
  &:hover {
    background: none;
    color: ${(props) => props.$isselect === "true" ? "#333333" : "#27C4D5"};
  }

  @media (max-width: 768px) {
    // padding: 0 5%;
  }
`;

const ArrowLeft = styled(iconLeft)`
  flex: 1;
  width: auto;
  height: 50%;
  cursor: pointer;
  fill: #121212;
  stroke: #121212;
  // margin: 0 25px;
  &:hover {
    fill: #27C4D5;
    stroke: #27C4D5;
  }

  @media (max-width: 768px) {
    // margin: 0 5%;
  }
`;

const ArrowRight = styled(iconRight)`
  flex: 1;
  width: auto;
  height: 50%;
  cursor: pointer;
  fill: #121212;
  stroke: #121212;
  // margin: 0 25px;
  &:hover {
    fill: #27C4D5;
    stroke: #27C4D5;
  }

  @media (max-width: 768px) {
    // margin: 0 5%;
  }
`;

interface ISize {
  top: number;
  h: number;
}

const VerticalScrollSection = ({
  datas,
}) => {
  const [yearId, setYearId] = useState<number>(0);
  const historyRef = useRef(null);
  const scrollRef = useRef(null);

  const [dataSizeList, setDataSizeList] = useState<ISize[]>();

  const [isScroll, setIsScroll] = useState<boolean>(true);

  const handlePrev = (index: number) => {
    if(index - 1 < 0) return;
    setIsScroll(false);
    document.getElementById(`year${index - 1}`).scrollIntoView({ behavior: 'smooth', block: "start" });

    setYearId(index - 1);
  };
  
  const handleNext = (index: number) => {
    if(index + 1 > datas.length - 1) return;
    setIsScroll(false);
    document.getElementById(`year${index + 1}`).scrollIntoView({ behavior: 'smooth', block: "start" });

    setYearId(index + 1);
  };

  const _setYearId = (index: number) => {
    setIsScroll(false);
    document.getElementById(`year${index}`).scrollIntoView({ behavior: 'smooth', block: "start" });
    setYearId(index);
  };

  useEffect(() => {
  }, [yearId]);

  const handleWheel = (e) => {
  };

  const handleScroll = (e) => {
    let timeout;
    if(timeout) clearTimeout(timeout);

    let currentSectionIndex = 0;

    if(isScroll) {
      dataSizeList.forEach((el, index) => {
        if(scrollRef?.current.scrollTop > el.top) {
          currentSectionIndex = index;
        }
      });
      if(currentSectionIndex !== yearId) {
        // timeout = setTimeout(() => {
          setYearId(currentSectionIndex);
        // }, 200);
      }
    } else {
      currentSectionIndex = yearId;
    }

    setTimeout(() => {
      if(!isScroll) setIsScroll(true);
      document.getElementById(`nav${currentSectionIndex}`)?.scrollIntoView({ behavior: 'smooth', block: "nearest", inline: 'center' });
    }, 700);
  };

  useEffect(() => {
    let items = [];
    datas.forEach((d, i) => {
      items.push({
        top: items[i-1] ? items[i-1].top + items[i-1].h - 60 : 0,
        h: document.getElementById(`year${i}`).scrollHeight,
      });
    });
    setDataSizeList(items);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container ref={historyRef}>
      <Box display={"flex"} w={"100%"} justifyContent={"center"} padding={"10px"} mb={"20px"}>
        <Heading as={"h3"} color={"#121212"}>연혁</Heading>
      </Box>
      <NavSection>
        <ArrowLeft onClick={() => handlePrev(yearId)}/>
        <RowBox>
          <NavBox>
            {datas?.map((item, index) => {
              return(
                <StyledButton 
                  key={index} 
                  id={`nav${index}`} 
                  className='nav' 
                  $isselect={(yearId === index).toString()} 
                  onClick={() => _setYearId(index)}
                >
                  {item.year}
                </StyledButton>
              )
            })}
          </NavBox>
        </RowBox>
        <ArrowRight onClick={() => handleNext(yearId)}/>
      </NavSection>
      <ScrollSection ref={scrollRef} onScroll={handleScroll} onWheel={handleWheel}>
        {datas?.map((data, yId) => {
          return (
            <Box key={yId} id={`year${yId}`} w={"100%"} h={"fit-content"} display={"flex"} flexDir={"column"} alignItems={"center"} p={"10% 5% 5%"}>
              <Text color={yearId === yId ? "#27C4D5" : "#D9D9D9"} fontSize={"60px"} mb={"30px"}>{`${data.year}`}</Text>
              {data.datas?.map((data, dId) => {
                return (
                  <Stack key={dId} w={"100%"} alignItems={"center"} mb={"10px"}>
                    <Text color={yearId === yId ? "#333333" : "#D9D9D9"} fontSize={"20px"}>{data.title && data.title !== "" ? data.title : data.month}</Text>
                    <Divider w={"100%"} border={"1px solid #969696"} orientation='horizontal' m={"3% 0"} />
                    {data.desc?.map((desc, i) => {
                      return (
                        <Text key={i} color={yearId === yId ? "#333333" : "#D9D9D9"} textAlign={"center"}>{desc}</Text>
                      )
                    })}
                  </Stack>
                )
              })}
            </Box>
          )
        })}
        <Box w={"100%"} minH={"150px"}>

        </Box>
      </ScrollSection>
    </Container>
  );
};

export default VerticalScrollSection;